var map = {
	"./Img-01.jpg": 693,
	"./Img-02.jpg": 694,
	"./Img-03.jpg": 695,
	"./Img-05.jpg": 696,
	"./Img-07.jpg": 697,
	"./K.png": 698,
	"./b.png": 699,
	"./blog-grid/author_img.png": 323,
	"./blog-grid/blog_list1.jpg": 700,
	"./blog-grid/blog_list2.jpg": 701,
	"./blog-grid/blog_list3.jpg": 702,
	"./blog-grid/blog_list4.jpg": 703,
	"./blog-grid/blog_single.png": 324,
	"./blog-grid/comment1.png": 325,
	"./blog-grid/comment2.png": 326,
	"./blog-grid/post_1.jpg": 704,
	"./blog-grid/post_2.jpg": 705,
	"./blog-grid/post_3.jpg": 706,
	"./blog-grid/post_4.jpg": 707,
	"./blog-grid/post_img_1.png": 327,
	"./blog-grid/post_img_2.png": 328,
	"./blog-grid/post_img_3.png": 329,
	"./br_logo.png": 708,
	"./breadcrumb/banner_bg.png": 709,
	"./breadcrumb/service.png": 710,
	"./breadcrumb/service_details.png": 711,
	"./breadcrumb/service_details_one.png": 712,
	"./cart1.jpg": 713,
	"./cart2.jpg": 714,
	"./cryptocurrency-infographic.jpg": 715,
	"./erp-home/action_img.png": 108,
	"./erp-home/background.png": 330,
	"./erp-home/banner_shap.png": 331,
	"./erp-home/cloud-computing.png": 332,
	"./erp-home/cloud_01.png": 109,
	"./erp-home/cloud_02.png": 110,
	"./erp-home/cloud_03.png": 111,
	"./erp-home/cloud_04.png": 112,
	"./erp-home/cloud_05.png": 113,
	"./erp-home/cloud_06.png": 114,
	"./erp-home/crm_img1.jpg": 333,
	"./erp-home/crm_img2.jpg": 334,
	"./erp-home/crm_img3.jpg": 335,
	"./erp-home/erp_dashboard.jpg": 115,
	"./erp-home/erp_icon1.png": 336,
	"./erp-home/erp_icon2.png": 337,
	"./erp-home/erp_icon3.png": 338,
	"./erp-home/erp_icon4.png": 339,
	"./erp-home/erp_icon5.png": 340,
	"./erp-home/erp_icon6.png": 341,
	"./erp-home/growth.png": 342,
	"./erp-home/img/01.png": 116,
	"./erp-home/img/02.png": 117,
	"./erp-home/img/03.png": 118,
	"./erp-home/img/04.png": 119,
	"./erp-home/img/05.png": 120,
	"./erp-home/img/06.png": 121,
	"./erp-home/img/07.png": 122,
	"./erp-home/img/08.png": 123,
	"./erp-home/img/09.png": 124,
	"./erp-home/img/10.png": 125,
	"./erp-home/img/11.png": 126,
	"./erp-home/img/12.png": 127,
	"./erp-home/img/13.png": 128,
	"./erp-home/img/14.png": 129,
	"./erp-home/img/15.png": 130,
	"./erp-home/img/16.png": 131,
	"./erp-home/img/17.png": 132,
	"./erp-home/img/18.png": 133,
	"./erp-home/img/19.png": 134,
	"./erp-home/img/20.png": 135,
	"./erp-home/quote.png": 343,
	"./erp-home/rocket.png": 136,
	"./erp-home/settings1.png": 344,
	"./erp-home/shape.png": 345,
	"./erp-home/testimonial_img.jpg": 346,
	"./erp-home/testimonial_img2.jpg": 347,
	"./error_bg.png": 716,
	"./favicon.png": 717,
	"./home-chat/Messages.jpg": 348,
	"./home-chat/Messages.png": 137,
	"./home-chat/book.png": 138,
	"./home-chat/box.png": 139,
	"./home-chat/chat.png": 140,
	"./home-chat/chat_01.png": 349,
	"./home-chat/chat_02.png": 350,
	"./home-chat/chat_icon.png": 351,
	"./home-chat/cloud.png": 141,
	"./home-chat/dashboard.png": 352,
	"./home-chat/dot.png": 353,
	"./home-chat/get_started_bg.png": 354,
	"./home-chat/john.png": 142,
	"./home-chat/left_leaf.png": 143,
	"./home-chat/live_chat.png": 144,
	"./home-chat/mobile.png": 145,
	"./home-chat/panguin_img_one.png": 146,
	"./home-chat/panguin_img_three.png": 147,
	"./home-chat/panguin_img_two.png": 148,
	"./home-chat/pluse.png": 149,
	"./home-chat/richard.png": 150,
	"./home-chat/right_leaf.png": 151,
	"./home-chat/skyp_1.png": 355,
	"./home-chat/skyp_2.png": 356,
	"./home-chat/support_dashboard.jpg": 357,
	"./home-chat/triangle.png": 152,
	"./home-chat/video_icon.png": 358,
	"./home-event/about.jpg": 153,
	"./home-event/banner_bg.jpg": 154,
	"./home-event/chat.png": 359,
	"./home-event/conference.jpg": 26,
	"./home-event/digital.jpg": 42,
	"./home-event/dot.png": 360,
	"./home-event/image_01.jpg": 361,
	"./home-event/image_02.jpg": 362,
	"./home-event/image_03.jpg": 363,
	"./home-event/image_04.jpg": 364,
	"./home-event/image_05.jpg": 365,
	"./home-event/image_06.jpg": 366,
	"./home-event/instragram1.jpg": 367,
	"./home-event/instragram2.jpg": 368,
	"./home-event/instragram3.jpg": 369,
	"./home-event/instragram4.jpg": 370,
	"./home-event/instragram5.jpg": 371,
	"./home-event/instragram6.jpg": 372,
	"./home-event/leader.png": 373,
	"./home-event/logo_09.jpg": 374,
	"./home-event/logo_10.jpg": 375,
	"./home-event/logo_11.jpg": 376,
	"./home-event/logo_12.jpg": 377,
	"./home-event/marker.png": 155,
	"./home-event/marketing.jpg": 43,
	"./home-event/meetup.png": 378,
	"./home-event/price_shap.png": 379,
	"./home-event/promo.jpg": 156,
	"./home-event/team1.jpg": 380,
	"./home-event/team2.jpg": 381,
	"./home-event/team3.jpg": 382,
	"./home-event/timer.png": 157,
	"./home-security/about_img_1.jpg": 383,
	"./home-security/about_img_2.jpg": 384,
	"./home-security/apple_icon.png": 158,
	"./home-security/banner.png": 159,
	"./home-security/leaf_clients1.png": 160,
	"./home-security/leaf_clients2.png": 161,
	"./home-security/mackbook.png": 162,
	"./home-security/padlock.png": 163,
	"./home-security/real-estate.png": 385,
	"./home-security/rocket.png": 386,
	"./home-security/security_1.png": 387,
	"./home-security/security_2.png": 388,
	"./home-security/security_3.png": 389,
	"./home-security/security_4.png": 390,
	"./home-security/shap.png": 164,
	"./home-security/sheld_bg.png": 165,
	"./home-security/shield.png": 166,
	"./home-security/windows_icon.png": 167,
	"./home-software/analytices1.png": 391,
	"./home-software/analytices2.png": 392,
	"./home-software/analytices3.png": 393,
	"./home-software/analytices4.png": 394,
	"./home-software/analytices5.jpg": 395,
	"./home-software/analytices6.jpg": 396,
	"./home-software/analytices7.jpg": 397,
	"./home-software/analytices8.jpg": 398,
	"./home-software/case.png": 399,
	"./home-software/down_bg.png": 400,
	"./home-software/elements_five.png": 401,
	"./home-software/elements_four.png": 402,
	"./home-software/elements_one.png": 403,
	"./home-software/elements_six.png": 404,
	"./home-software/elements_three.png": 405,
	"./home-software/elements_two.png": 406,
	"./home-software/line_02.png": 407,
	"./home-software/logo_01.png": 168,
	"./home-software/logo_02.png": 169,
	"./home-software/logo_03.png": 170,
	"./home-software/logo_04.png": 171,
	"./home-software/logo_05.png": 172,
	"./home-software/logo_06.png": 173,
	"./home-software/logo_07.png": 174,
	"./home-software/logo_08.png": 175,
	"./home-software/logo_09.png": 408,
	"./home-software/logo_10.png": 409,
	"./home-software/logo_11.png": 410,
	"./home-software/logo_12.png": 411,
	"./home-software/mackbook.png": 412,
	"./home-software/pie.png": 413,
	"./home-software/setup_img1.png": 414,
	"./home-software/setup_img2.png": 415,
	"./home-software/setup_img3.png": 416,
	"./home-software/shap_3.png": 417,
	"./home-software/shap_one.png": 418,
	"./home-software/shap_two.png": 419,
	"./home-tracking/activity_icon.png": 176,
	"./home-tracking/aliexpress.png": 420,
	"./home-tracking/amazon.png": 421,
	"./home-tracking/analyze_icon.png": 177,
	"./home-tracking/apple.png": 422,
	"./home-tracking/computer_tracking_img.jpg": 423,
	"./home-tracking/crismas.png": 424,
	"./home-tracking/cta.png": 178,
	"./home-tracking/cta_pattern_bg.jpg": 425,
	"./home-tracking/google.png": 426,
	"./home-tracking/left-dot.png": 427,
	"./home-tracking/month.png": 428,
	"./home-tracking/right-dot.png": 429,
	"./home-tracking/tesla.png": 430,
	"./home-tracking/time_icon.png": 179,
	"./home-tracking/tracking_banner_img.png": 180,
	"./home-tracking/watch_1.png": 431,
	"./home-tracking/windows.png": 432,
	"./home2/action_bg.png": 718,
	"./home2/file.png": 181,
	"./home2/inbox.png": 182,
	"./home2/report.png": 183,
	"./home2/undraw.png": 184,
	"./home3/action_image.png": 261,
	"./home3/dimond.png": 262,
	"./home3/logo_01.png": 54,
	"./home3/logo_02.png": 92,
	"./home3/logo_03.png": 93,
	"./home3/logo_04.png": 55,
	"./home3/logo_05.png": 56,
	"./home3/p_feature1.png": 263,
	"./home3/prototype_banner_img.png": 264,
	"./home3/prototype_banner_img2.png": 265,
	"./home3/psd.png": 266,
	"./home3/saas.png": 267,
	"./home3/tab.png": 268,
	"./home4/action_shap.png": 269,
	"./home4/author_img.png": 270,
	"./home4/banner_bg.png": 90,
	"./home4/banner_img.png": 91,
	"./home4/divider.png": 94,
	"./home4/dot.png": 95,
	"./home4/fe42e8e9747c20b0e51b3c7745509312.jpg": 271,
	"./home4/icon01.png": 272,
	"./home4/icon02.png": 273,
	"./home4/icon3.png": 274,
	"./home4/icon_04.png": 275,
	"./home4/icon_05.png": 276,
	"./home4/icon_shape1.png": 277,
	"./home4/icon_shape2.png": 278,
	"./home4/icon_shape3.png": 279,
	"./home4/icon_shape4.png": 280,
	"./home4/process_1.png": 281,
	"./home4/process_2.png": 282,
	"./home4/process_3.png": 283,
	"./home4/process_4.png": 284,
	"./home4/process_5.png": 285,
	"./home4/shape.png": 286,
	"./home4/team1.jpg": 96,
	"./home4/team2.jpg": 97,
	"./home4/team3.png": 98,
	"./home4/team4.jpg": 99,
	"./home4/team5.jpg": 100,
	"./home4/team6.jpg": 101,
	"./home4/work1.png": 287,
	"./home4/work2.png": 288,
	"./home4/work3.png": 289,
	"./home5/01.jpg": 185,
	"./home5/02.jpg": 186,
	"./home5/03.jpg": 187,
	"./home5/banner_img.png": 188,
	"./home5/design1.png": 189,
	"./home5/design2.png": 190,
	"./home5/featured_bg_shape.png": 433,
	"./home5/featured_img1.png": 191,
	"./home5/icon1.png": 434,
	"./home5/icon2.png": 435,
	"./home5/icon3.png": 436,
	"./home5/icon_shape.png": 192,
	"./home5/php.jpg": 193,
	"./home5/shap_tecture.png": 437,
	"./home6/dashboard.jpg": 194,
	"./home6/featured_img_one.jpg": 195,
	"./home6/featured_img_two.jpg": 196,
	"./home6/feedback_img_one.png": 438,
	"./home6/feedback_img_three.png": 439,
	"./home6/feedback_img_two.png": 440,
	"./home6/logo_01.png": 441,
	"./home6/logo_02.png": 442,
	"./home6/logo_03.png": 443,
	"./home6/logo_04.png": 444,
	"./home6/logo_05.png": 445,
	"./home6/shape-1.png": 197,
	"./home6/shape2.png": 198,
	"./home6/trust_img.png": 446,
	"./home6/trust_img2.png": 447,
	"./home7/01.png": 448,
	"./home7/02.png": 449,
	"./home7/03.png": 450,
	"./home7/app.png": 451,
	"./home7/banner.png": 719,
	"./home7/google_icon.png": 452,
	"./home7/iPhoneX2.png": 453,
	"./home7/iPhonex.png": 454,
	"./home7/screenshot1.png": 60,
	"./home7/screenshot2.png": 455,
	"./home7/screenshot3.png": 199,
	"./home7/screenshot4.png": 456,
	"./home7/screenshot5.png": 457,
	"./home7/team_01.jpg": 720,
	"./home7/team_02.jpg": 721,
	"./home7/team_03.jpg": 722,
	"./home7/team_04.jpg": 723,
	"./home7/testimonial_author_img.png": 61,
	"./home7/text_one.png": 458,
	"./home7/text_three.png": 459,
	"./home7/text_two.png": 460,
	"./home8/banner_img.png": 322,
	"./home8/dot.png": 724,
	"./home8/fact.png": 725,
	"./home8/service_item_03.png": 726,
	"./home9/featured_img.png": 104,
	"./home9/featured_img_two.png": 105,
	"./home9/flag.png": 291,
	"./home9/footer.png": 292,
	"./home9/icon1.png": 59,
	"./home9/icon2.png": 40,
	"./home9/icon3.png": 293,
	"./home9/icon4.png": 294,
	"./home9/icon5.png": 295,
	"./home9/icon6.png": 296,
	"./home9/icon7.png": 297,
	"./home9/icon8.png": 298,
	"./home9/icon_shape.png": 39,
	"./home9/icon_shape_two.png": 299,
	"./home9/logo1.png": 300,
	"./home9/logo2.png": 301,
	"./home9/logo3.png": 302,
	"./home9/logo4.png": 303,
	"./home9/logo5.png": 304,
	"./home9/logo6.png": 305,
	"./home9/logo7.png": 306,
	"./home9/logo8.png": 307,
	"./home9/mac.png": 102,
	"./home9/map.png": 308,
	"./home9/shape-footer.png": 309,
	"./home9/shape.png": 103,
	"./home9/shape_two.png": 310,
	"./home9/testimonial_img.png": 106,
	"./home9/testimonial_img2.png": 107,
	"./home9/triangle_bottom.png": 311,
	"./home9/triangle_top.png": 312,
	"./hosting/action_img.png": 461,
	"./hosting/business1.png": 462,
	"./hosting/business2.png": 463,
	"./hosting/h_blog1.jpg": 464,
	"./hosting/h_blog2.jpg": 465,
	"./hosting/hosting-image.png": 200,
	"./hosting/hosting_action_bg.png": 201,
	"./hosting/icon1.png": 466,
	"./hosting/icon10.png": 467,
	"./hosting/icon2.png": 468,
	"./hosting/icon3.png": 469,
	"./hosting/icon4.png": 470,
	"./hosting/icon5.png": 471,
	"./hosting/icon6.png": 472,
	"./hosting/icon7.png": 473,
	"./hosting/icon8.png": 474,
	"./hosting/icon9.png": 475,
	"./hosting/line_01.png": 202,
	"./hosting/line_02.png": 203,
	"./hosting/line_03.png": 204,
	"./hosting/line_04.png": 205,
	"./hosting/line_05.png": 206,
	"./hosting/line_06.png": 207,
	"./hosting/line_07.png": 208,
	"./hosting/line_08.png": 209,
	"./hosting/map.png": 476,
	"./hosting/region_map.png": 477,
	"./login_img.png": 727,
	"./login_img2.png": 728,
	"./logo-3-2x.png": 729,
	"./logo-sticky-2x.png": 730,
	"./logo-sticky.png": 731,
	"./logo-sticky2.png": 732,
	"./logo-sticky3.png": 733,
	"./logo-sticky4.png": 734,
	"./logo.png": 38,
	"./logo2.png": 37,
	"./logo2x-2.png": 735,
	"./logo2x.png": 736,
	"./logo3.png": 321,
	"./logo4.png": 737,
	"./logo7.png": 738,
	"./logo8.png": 739,
	"./mega-menu-img/Prototyping_Tool.jpg": 740,
	"./mega-menu-img/analytices.jpg": 741,
	"./mega-menu-img/coming_img.jpg": 742,
	"./mega-menu-img/erp.jpg": 743,
	"./mega-menu-img/home-animation.jpg": 744,
	"./mega-menu-img/home-chat.jpg": 745,
	"./mega-menu-img/home-event.jpg": 746,
	"./mega-menu-img/home-security.jpg": 747,
	"./mega-menu-img/home-track.jpg": 748,
	"./mega-menu-img/home1.jpg": 749,
	"./mega-menu-img/home10.jpg": 750,
	"./mega-menu-img/home11.jpg": 751,
	"./mega-menu-img/home12.jpg": 752,
	"./mega-menu-img/home13.jpg": 753,
	"./mega-menu-img/home14.jpg": 754,
	"./mega-menu-img/home15.jpg": 755,
	"./mega-menu-img/home16.jpg": 756,
	"./mega-menu-img/home17.jpg": 757,
	"./mega-menu-img/home2.jpg": 758,
	"./mega-menu-img/home3.jpg": 759,
	"./mega-menu-img/home4.jpg": 760,
	"./mega-menu-img/home5.jpg": 761,
	"./mega-menu-img/home6.jpg": 762,
	"./mega-menu-img/home7.jpg": 763,
	"./mega-menu-img/home8.jpg": 764,
	"./mega-menu-img/home9.jpg": 765,
	"./mega-menu-img/hosting.jpg": 766,
	"./mega-menu-img/icon/app-d.png": 767,
	"./mega-menu-img/icon/blup.png": 768,
	"./mega-menu-img/pos.jpg": 769,
	"./mega-menu-img/saas2-slider.png": 770,
	"./mega-menu-img/support.jpg": 771,
	"./new-home/back_bg.png": 478,
	"./new-home/banner.png": 210,
	"./new-home/briteverify.png": 211,
	"./new-home/campfire.png": 62,
	"./new-home/email.png": 212,
	"./new-home/kissmetrics.png": 63,
	"./new-home/metorik.png": 64,
	"./new-home/nicereply-1.png": 65,
	"./new-home/p-1.png": 213,
	"./new-home/p-2.png": 214,
	"./new-home/p-3.png": 215,
	"./new-home/tab.png": 216,
	"./new-home/tab_2.png": 217,
	"./new-home/tab_3.png": 218,
	"./new-home/ticket-support.png": 219,
	"./new-home/tree-left.png": 220,
	"./new-home/tree-right.png": 221,
	"./new-home/tree.png": 222,
	"./new-home/update.png": 66,
	"./new-home/webhooks.png": 67,
	"./new-home/wedsite.png": 223,
	"./new/01.png": 772,
	"./new/0111.png": 314,
	"./new/02.png": 773,
	"./new/0222.png": 313,
	"./new/03.png": 774,
	"./new/04.png": 775,
	"./new/05.png": 776,
	"./new/06.png": 777,
	"./new/app_screen.png": 778,
	"./new/blog/blog_grid_1.jpg": 479,
	"./new/blog/blog_grid_2.jpg": 480,
	"./new/blog/blog_grid_3.jpg": 481,
	"./new/blog/blog_grid_4.jpg": 482,
	"./new/blog/blog_grid_5.jpg": 483,
	"./new/blog/blog_grid_6.jpg": 484,
	"./new/blog/blog_grid_7.jpg": 485,
	"./new/blog/blog_grid_8.jpg": 486,
	"./new/case/case_01.jpg": 779,
	"./new/case/case_02.jpg": 780,
	"./new/case/case_03.jpg": 781,
	"./new/case/case_04.jpg": 782,
	"./new/case/case_05.jpg": 783,
	"./new/case/case_06.jpg": 784,
	"./new/case/case_07.jpg": 785,
	"./new/case/case_08.jpg": 786,
	"./new/case/case_09.jpg": 787,
	"./new/case/case_10.jpg": 788,
	"./new/case/case_11.jpg": 789,
	"./new/case/case_12.jpg": 790,
	"./new/case/case_details_01.jpg": 791,
	"./new/case/case_details_02.jpg": 792,
	"./new/case/case_details_03.jpg": 793,
	"./new/case/parallax.png": 794,
	"./new/coming_soon_bg.png": 795,
	"./new/company.jpg": 796,
	"./new/cup.png": 316,
	"./new/digital_img.png": 797,
	"./new/error.png": 487,
	"./new/features_01.png": 798,
	"./new/feedback_shap.png": 799,
	"./new/home-split/contact.png": 800,
	"./new/iPhoneX.png": 31,
	"./new/icon.png": 801,
	"./new/icon/icon1.png": 802,
	"./new/icon/icon2.png": 803,
	"./new/icon2.png": 804,
	"./new/icon3.png": 805,
	"./new/intregration_1.png": 317,
	"./new/intregration_2.png": 318,
	"./new/intregration_3.png": 319,
	"./new/intregration_4.png": 320,
	"./new/laptop.png": 488,
	"./new/laptop_two.png": 806,
	"./new/leaf.png": 315,
	"./new/line_01.png": 489,
	"./new/line_02.png": 490,
	"./new/line_03.png": 491,
	"./new/logo_01.png": 807,
	"./new/logo_02.png": 808,
	"./new/logo_03.png": 809,
	"./new/logo_04.png": 810,
	"./new/logo_05.png": 811,
	"./new/member_01.jpg": 812,
	"./new/new_shape.png": 813,
	"./new/phone.png": 492,
	"./new/price_bg.png": 814,
	"./new/shape_bg.png": 815,
	"./new/solution_01.jpg": 816,
	"./new/solution_02.jpg": 817,
	"./new/startup_banner_bg.png": 818,
	"./new/startup_banner_img.png": 493,
	"./new/startup_shap.png": 819,
	"./new/tab_shape_bg.png": 820,
	"./new/testimonial_bg.png": 821,
	"./new/testimonial_bg_shap.png": 822,
	"./new/testimonial_bg_two.png": 823,
	"./new/video_bg.jpg": 824,
	"./new/video_img_01.png": 825,
	"./new/video_img_02.jpg": 826,
	"./new/web_image.jpg": 30,
	"./new_logo.png": 827,
	"./pages_back.jpg": 828,
	"./portfolio-details/pr_details1.jpg": 494,
	"./portfolio-details/pr_details2.jpg": 495,
	"./portfolio-details/pr_details3.jpg": 496,
	"./portfolio-details/pr_details4.jpg": 497,
	"./portfolio/2-columns/grid1.jpg": 498,
	"./portfolio/2-columns/grid2.jpg": 499,
	"./portfolio/2-columns/grid3.jpg": 500,
	"./portfolio/2-columns/grid4.jpg": 501,
	"./portfolio/2-columns/grid5.jpg": 502,
	"./portfolio/2-columns/grid6.jpg": 503,
	"./portfolio/2-columns/grid7.jpg": 504,
	"./portfolio/2-columns/grid8.jpg": 505,
	"./portfolio/3-columns/3_col_1.jpg": 506,
	"./portfolio/3-columns/3_col_10.jpg": 507,
	"./portfolio/3-columns/3_col_11.jpg": 508,
	"./portfolio/3-columns/3_col_12.jpg": 509,
	"./portfolio/3-columns/3_col_2.jpg": 510,
	"./portfolio/3-columns/3_col_3.jpg": 511,
	"./portfolio/3-columns/3_col_4.jpg": 512,
	"./portfolio/3-columns/3_col_5.jpg": 513,
	"./portfolio/3-columns/3_col_6.jpg": 514,
	"./portfolio/3-columns/3_col_7.jpg": 515,
	"./portfolio/3-columns/3_col_8.jpg": 516,
	"./portfolio/3-columns/3_col_9.jpg": 517,
	"./portfolio/full-width/full_1.jpg": 518,
	"./portfolio/full-width/full_10.jpg": 519,
	"./portfolio/full-width/full_11.jpg": 520,
	"./portfolio/full-width/full_12.jpg": 521,
	"./portfolio/full-width/full_2.jpg": 522,
	"./portfolio/full-width/full_3.jpg": 523,
	"./portfolio/full-width/full_4.jpg": 524,
	"./portfolio/full-width/full_5.jpg": 525,
	"./portfolio/full-width/full_6.jpg": 526,
	"./portfolio/full-width/full_7.jpg": 527,
	"./portfolio/full-width/full_8.jpg": 528,
	"./portfolio/full-width/full_9.jpg": 529,
	"./pos/High-end-all-in-one-dual-screen.png": 829,
	"./pos/b_dashboard.png": 830,
	"./pos/cash-register.png": 831,
	"./pos/chat.png": 832,
	"./pos/credit-card.png": 833,
	"./pos/delivery-truck.png": 834,
	"./pos/ezgif-1-997e5035cba4.png": 835,
	"./pos/fotter_shap.png": 836,
	"./pos/icon1.png": 837,
	"./pos/icon2.png": 838,
	"./pos/icon3.png": 839,
	"./pos/item1.png": 840,
	"./pos/item2.png": 841,
	"./pos/item3.png": 842,
	"./pos/laptop.png": 843,
	"./pos/leaf-left.png": 530,
	"./pos/leaf-right.png": 531,
	"./pos/mailbox.png": 844,
	"./pos/man.png": 532,
	"./pos/pattern_01.png": 845,
	"./pos/pattern_02.png": 846,
	"./pos/people.png": 533,
	"./pos/pos.png": 847,
	"./pos/pos_about_img.png": 848,
	"./pos/pos_blog_1.png": 849,
	"./pos/pos_blog_2.png": 850,
	"./pos/pos_blog_3.png": 851,
	"./pos/pos_slideshow1.jpg": 852,
	"./pos/pos_slideshow2.jpg": 853,
	"./pos/pos_slideshow3.jpg": 854,
	"./pos/shape.png": 855,
	"./pos/shape_bg.png": 856,
	"./pos/statistics.png": 857,
	"./pos/tab_pattern.png": 858,
	"./pos/wave_two.png": 859,
	"./pos/women.png": 534,
	"./price/one.png": 860,
	"./price/three.png": 861,
	"./price/two.png": 862,
	"./process/ASAN-logo-icon.png": 863,
	"./process/Avast_Antivirus.png": 864,
	"./process/UTorrent_(logo).png": 865,
	"./process/btFMmsoh.png": 866,
	"./process/logo-slack.png": 867,
	"./process/png-logo-design.png": 868,
	"./qoute.png": 869,
	"./saas/map.png": 870,
	"./seo/bike.png": 871,
	"./seo/car.png": 872,
	"./seo/cloud.png": 873,
	"./seo/cloud_bg.png": 874,
	"./seo/features_img.png": 875,
	"./seo/features_img_two.png": 876,
	"./seo/footer_bg.png": 877,
	"./seo/icon1.png": 878,
	"./seo/icon2.png": 879,
	"./seo/icon3.png": 880,
	"./seo/icon4.png": 881,
	"./seo/icon5.png": 882,
	"./seo/image.png": 883,
	"./seo/logo_01.png": 884,
	"./seo/logo_02.png": 885,
	"./seo/logo_03.png": 886,
	"./seo/logo_04.png": 887,
	"./seo/logo_05.png": 888,
	"./seo/logo_06.png": 889,
	"./seo/logo_07.png": 890,
	"./seo/logo_08.png": 891,
	"./seo/logo_09.png": 892,
	"./seo/shap.png": 893,
	"./seo/studies_img_one.jpg": 894,
	"./seo/studies_img_three.jpg": 895,
	"./seo/studies_img_two.jpg": 896,
	"./seo/triangle_one.png": 897,
	"./seo/triangle_three.png": 898,
	"./seo/triangle_two.png": 899,
	"./svg.svg": 900,
	"./teams/team_01.jpg": 535,
	"./teams/team_02.jpg": 536,
	"./teams/team_03.jpg": 537,
	"./teams/team_04.jpg": 538,
	"./teams/team_10.jpg": 539,
	"./teams/team_12.jpg": 540,
	"./teams/team_5.jpg": 541,
	"./teams/team_6.jpg": 542,
	"./teams/team_7.jpg": 543,
	"./teams/team_8.jpg": 544,
	"./teams/team_9.jpg": 545
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41;